import clsx from "clsx";

type LabelProps = {
  label: string;
  className?: string;
};

const Label = ({ label, className }: LabelProps) => {
  return (
    <div
      className={clsx(
        "absolute top-4 z-10 rounded-full bg-black bg-opacity-60 px-2 py-1 text-2xs font-normal text-neutral-100 lg:px-5 lg:py-2 lg:text-md",
        className
      )}
    >
      {label}
    </div>
  );
};

export default Label;
